import { Button, Col, Divider, Empty, Form, Input, Modal, Row, Segmented, Select, Table, Tooltip, Typography } from "antd";

import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { savePriseEnCharge, updatePriseEnCharge } from "../../../hooks/useHooks";
import axiosInstance from "../../../variables/api/axiosInstance";
import { DeleteOutlined, EditOutlined, PlusOutlined, ShopOutlined, UserOutlined } from "@ant-design/icons";
import { displayNumbers, formatAmount } from "../../../variables/numbersFunctions";
import AmountInputNumber from "../../../components/inputs/AmountInputNumber";

const { Text } = Typography;

const initPEC = {
    victime: {},
    etablissement: {},
    natureActe: "",
    codification: "",
    montant: 0,
    delaiValidite: "",
    dureeValidite: "",
    charge: [],
    sousEvaluations: [],
};

const { Option } = Select;

const AjouterPriseEnCharge = (props) => {
    const [modalPEC, setModalPEC] = useState(props?.open);
    const [pec, setPEC] = useState(() => ({ ...initPEC }));
    const [acteModal, setActeModal] = useState(false);
    const [actes, setActes] = useState([]);
    const [natureActes, setNatureActes] = useState([]);
    const [editActe, setEditActe] = useState(false);
    const [selectedActe, setSelectedActe] = useState();

    const [victimeState, setVictimeState] = useState("");
    const [sousEvaluationsState, setSousEvaluationsState] = useState("");
    const [etablissementState, setEtablissementState] = useState("");
    const [natureActeState, setNatureActeState] = useState("");
    const [codificationState, setCodificationState] = useState("");
    const [montantState, setMontantState] = useState("");
    const [delaiValiditeState, setDelaiValiditeState] = useState("");
    const [dvUnit, setDVUnit] = useState("M");
    const [sousEvaluations, setSousEvaluations] = useState([]);
    const [etablissements, setEtablissements] = useState([]);

    const resetModalState = () => {
        setPEC({ ...initPEC });
        setVictimeState("");
        setSousEvaluationsState("");
        setEtablissementState("");
        setNatureActeState("");
        setCodificationState("");
        setMontantState("");
        setDelaiValiditeState("");
        setActes([]);
        setEditActe(false);
        setSelectedActe(undefined);
        setDVUnit("M");
        setActeModal(false);
    };

    const handleCloseModal = () => {
        resetModalState();
        setModalPEC(false);
        props.setOpen && props.setOpen(false);
        props.onClose && props.onClose();
    };

    const isValidated = () => {
        if (
            victimeState === "success" &&
            etablissementState === "success" &&
            delaiValiditeState === "success"
        ) {
            return true;
        } else {
            if (victimeState !== "success") {
                setVictimeState("error");
            }
            if (etablissementState !== "success") {
                setEtablissementState("error");
            }
            if (delaiValiditeState !== "success") {
                setDelaiValiditeState("error");
            }
            return false;
        }
    };

    const [addVictimeLoading, setAddVictimeLoading] = useState(false);

    const addActe = () => {
        setEditActe(false);
        setSelectedActe(undefined);
        setActes((previous) => ([
            ...(previous || []),
            {
                acte: "",
                codificationActe: "",
                montantReclame: 0,
                montantRetenue: 0,
                montantExclu: 0,
            },
        ]));
        setActeModal(true);
    };

    useEffect(() => {
        axiosInstance
            .get(`/api/parametre/type/NATURE_ACTE`)
            .then((res) => {
                // Ranger par ordre alphabetique sur le libelleParametre
                const sorted = res.data.sort((a, b) => a.libelleParametre.localeCompare(b.libelleParametre));
                setNatureActes(sorted);
            })
            .catch((err) => console.error("Erreur récupération natures actes:", err));
    }, []);

    const handleSubmit = async () => {
        const validated = isValidated();
        if (!validated) {
            toast.error("Veuillez remplir tous les champs obligatoires");
            return;
        }
        if (!props?.sinistre?.codeId) {
            toast.error("Sinistre introuvable");
            return;
        }

        const payload = {
            ...pec,
            charge: actes.length > 0 ? actes : null,
        };

        try {
            setAddVictimeLoading(true);
            if (props.edit) {
                await updatePriseEnCharge(payload, props.sinistre.codeId);
                toast.success("Prise en charge mise à jour avec succès !");
            } else {
                await savePriseEnCharge(payload, props.sinistre.codeId);
                toast.success("Prise en charge ajoutée avec succès !");
            }
            resetModalState();
            setModalPEC(false);
            props.setOpen && props.setOpen(false);
            props.onSuccess && props.onSuccess();
            window.location.reload();
        } catch (error) {
            console.error(error);
            toast.error("Une erreur est survenue");
        } finally {
            setAddVictimeLoading(false);
        }
    };
    const handleChange = (e, nom) => {
        if (nom) {
            setPEC((previous) => ({ ...(previous || { ...initPEC }), [nom]: e }));
            return;
        }
        const { name, value } = e.target;
        if (name === "dureeValidite") {
            const nextValue = value === "" ? "" : `${value}${dvUnit}`;
            setPEC((previous) => ({ ...(previous || { ...initPEC }), [name]: nextValue }));
        } else {
            setPEC((previous) => ({ ...(previous || { ...initPEC }), [name]: value }));
        }
    };

    useEffect(() => {
        setModalPEC(props.open);
        if (!props.open) {
            resetModalState();
            return;
        }

        if (props.edit && props.priseEnCharge) {
            try {
                const cloned = JSON.parse(JSON.stringify(props.priseEnCharge));
                const { charge = [], ...rest } = cloned || {};
                setPEC({ ...initPEC, ...rest });
                setActes(Array.isArray(charge) ? charge : []);
                const unit = rest?.dureeValidite ? rest.dureeValidite.slice(-1) : "M";
                setDVUnit(unit || "M");
                setVictimeState("success");
                setEtablissementState("success");
                setDelaiValiditeState(rest?.dureeValidite ? "success" : "");
                setSousEvaluationsState("success");
                if (rest?.natureActe) setNatureActeState("success");
                if (rest?.codification) setCodificationState("success");
                setMontantState("success");
            } catch (error) {
                console.error("Erreur lors du chargement de la prise en charge :", error);
                resetModalState();
            }
        } else {
            resetModalState();
        }
    }, [props.open, props.edit, props.priseEnCharge]);

    useEffect(() => {
        if (!modalPEC) {
            return;
        }
        axiosInstance
            .get(`/api/etablissement`)
            .then((res) => {
                setEtablissements(res.data);
            })
            .catch((err) => {
                console.error("Erreur lors de la récupération des établissements :", err);
            });
        const sev =
            props?.sinistre?.evaluations?.flatMap((item) => item?.sousEvaluations || []) || [];
        setSousEvaluations(sev);
    }, [modalPEC, props.sinistre]);

    // Type de document : prise en charge (médical) vs bon de réparation (véhicule).
    const isBon = !!pec?.bonReparation;

    // Menu déroulant des actes filtré par DISCIPLINE : la PEC mécanique (bon de réparation) propose les
    // actes « MECANIQUE », la PEC médicale les actes « MEDICAL ». Les actes non encore requalifiés (type
    // vide) restent proposés dans les DEUX (à requalifier dans /autre-parametres/nature-acte pour les
    // faire disparaître de la discipline opposée).
    const disciplineAttendue = isBon ? "MECANIQUE" : "MEDICAL";
    const natureActesFiltres = natureActes.filter((na) => !na?.type || na.type === disciplineAttendue);
    const L = {
        beneficiaire: isBon ? "Bénéficiaire" : "Victime",
        etablissement: isBon ? "Garage / Atelier" : "Etablissement",
        etablissementPh: isBon ? "Sélectionnez le garage / l'atelier" : "Sélectionnez l'établissement",
        nature: isBon ? "Type de réparation" : "La nature de l'acte",
        naturePh: isBon ? "Type de réparation" : "Nature de l'acte de la prise en charge",
        codification: isBon ? "Référence" : "Codification de l'acte",
        codificationPh: isBon ? "Référence" : "Codification de l'acte",
        cout: isBon ? "Coût de la réparation" : "Coût de l'acte",
        listeTitre: isBon ? "*Les différents travaux / pièces :" : "*Les différents actes de cette prise en charge:",
        acteCol: isBon ? "Travaux / Pièce" : "Acte",
        acteLabel: isBon ? "Travaux / Pièce" : "Acte",
        addActe: isBon ? "Ajouter un travail / une pièce" : "Ajouter un acte",
        actePh: isBon ? "Désignation des travaux / de la pièce" : "Acte de la prise en charge",
    };

    const selectAfter = (
        <Select
            defaultValue="M"
            onSelect={(value) => {
                setDVUnit(value);
                setPEC((previous) => {
                    const current = previous || { ...initPEC };
                    const rawDuration = current?.dureeValidite ? parseInt(current.dureeValidite, 10) : NaN;
                    if (Number.isNaN(rawDuration)) {
                        return { ...current };
                    }
                    return { ...current, dureeValidite: `${rawDuration}${value}` };
                });
            }}
            value={dvUnit}
        >
            <Option value="M">Mois</Option>
            <Option value="J">Jour(s)</Option>
            <Option value="A">Année(s)</Option>
            <Option value="H">Heure(s)</Option>
        </Select>
    );

    // ── Colonnes du tableau des actes / travaux (rendu Ant Design) ──────────
    const acteColumns = [
        {
            title: L.acteCol,
            dataIndex: "acte",
            key: "acte",
            render: (v) => v || <Text type="secondary">—</Text>,
        },
        {
            title: "Montant réclamé",
            dataIndex: "montantReclame",
            key: "montantReclame",
            align: "right",
            render: (v) => displayNumbers(v),
        },
        {
            title: "Montant retenu",
            key: "montantRetenue",
            align: "right",
            render: (_, item) => (
                <Text strong>
                    {displayNumbers(item?.montantRetenue ? item?.montantRetenue : item?.montantReclame - item?.montantExclu)}
                </Text>
            ),
        },
        {
            title: "Montant exclu",
            dataIndex: "montantExclu",
            key: "montantExclu",
            align: "right",
            render: (v) => displayNumbers(v),
        },
        {
            title: "Action",
            key: "action",
            align: "center",
            width: 110,
            render: (_, item, index) => (
                <div style={{ display: "flex", gap: 6, justifyContent: "center" }}>
                    <Tooltip title="Modifier">
                        <Button
                            size="small"
                            onClick={() => {
                                setSelectedActe(index);
                                setEditActe(true);
                                setActeModal(true);
                            }}
                            shape="circle"
                            icon={<EditOutlined />}
                        />
                    </Tooltip>
                    <Tooltip title="Supprimer">
                        <Button
                            size="small"
                            danger
                            onClick={() => {
                                setActes((previous) => {
                                    const next = [...previous];
                                    next.splice(index, 1);
                                    const totalRetenu = next.reduce(
                                        (acc, acte) => acc + Number(acte?.montantRetenue || 0),
                                        0
                                    );
                                    setPEC((prev) => ({ ...(prev || { ...initPEC }), montant: totalRetenu }));
                                    return next;
                                });
                                toast.success("Acte supprimé avec succès");
                            }}
                            shape="circle"
                            icon={<DeleteOutlined />}
                        />
                    </Tooltip>
                </div>
            ),
        },
    ];

    const validateStatusOf = (state) => (state === "error" ? "error" : "");

    return (
        <Modal
            title={
                <span>
                    {isBon ? <ShopOutlined style={{ marginRight: 8 }} /> : <UserOutlined style={{ marginRight: 8 }} />}
                    {`${props.edit ? "Modifier" : "Nouvelle"} ${isBon ? "· bon de réparation" : "· prise en charge"}`}
                </span>
            }
            centered
            open={modalPEC}
            onOk={handleSubmit}
            onCancel={handleCloseModal}
            confirmLoading={addVictimeLoading}
            width={980}
            okText={props.edit ? "Enregistrer les modifications" : "Enregistrer"}
            cancelText="Annuler"
            styles={{ body: { paddingTop: 8 } }}
        >
            {/* Type de document : Prise en charge (médical) ou Bon de réparation (véhicule) */}
            <div style={{ display: "flex", justifyContent: "center", marginBottom: 12 }}>
                <Segmented
                    size="large"
                    value={isBon ? "BON" : "PEC"}
                    onChange={(value) => handleChange(value === "BON", "bonReparation")}
                    options={[
                        { label: "Prise en charge", value: "PEC", icon: <UserOutlined /> },
                        { label: "Bon de réparation", value: "BON", icon: <ShopOutlined /> },
                    ]}
                />
            </div>

            <Form layout="vertical" requiredMark="optional">
                <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <Form.Item
                            label={L.beneficiaire}
                            required
                            validateStatus={validateStatusOf(victimeState)}
                            help={victimeState === "error" ? `${L.beneficiaire} obligatoire` : undefined}
                        >
                            <Select
                                id="victime"
                                name="victime"
                                style={{ width: "100%" }}
                                placeholder="Sélectionnez la victime"
                                // `optionFilterProp` était déjà posé plus bas mais restait inopérant
                                // sans showSearch : la recherche n'était pas activée.
                                showSearch
                                options={(props?.sinistre?.victimes || []).map((item) => {
                                    // Le nom peut être porté par `personne` (cas courant) ou directement
                                    // sur la victime selon la source des données.
                                    const nomComplet = [
                                        item?.personne?.nom || item?.nom,
                                        item?.personne?.prenom || item?.prenom,
                                    ].filter(Boolean).join(" ").trim();
                                    return {
                                        value: JSON.stringify(item),
                                        // Repli OBLIGATOIRE : sans label non vide, Ant Design affiche la
                                        // `value` (l'objet victime sérialisé en JSON) dans la liste.
                                        // On garde un identifiant pour rester distinctif si le nom manque.
                                        label: nomComplet || `Victime ${item?.histCodeId || item?.historiqueId || ""}`.trim(),
                                    };
                                })}
                                value={pec?.victime && Object.keys(pec.victime || {}).length
                                    ? JSON.stringify(pec.victime)
                                    : undefined}
                                onChange={(value) => {
                                    if (!value) {
                                        handleChange({}, "victime");
                                        setVictimeState("error");
                                        return;
                                    }
                                    handleChange(JSON.parse(value), "victime");
                                    setVictimeState("success");
                                }}
                                optionFilterProp="label"
                                allowClear
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item
                            label={L.etablissement}
                            required
                            validateStatus={validateStatusOf(etablissementState)}
                            help={etablissementState === "error" ? `${L.etablissement} obligatoire` : undefined}
                        >
                            <Select
                                id="etablissement"
                                name="etablissement"
                                placeholder={L.etablissementPh}
                                style={{ width: "100%" }}
                                // Recherche en saisissant le nom. Le filtre porte sur `label`
                                // (optionFilterProp plus bas) car la `value` est l'objet sérialisé en
                                // JSON : filtrer dessus matcherait n'importe quel champ interne.
                                showSearch
                                notFoundContent="Aucun établissement trouvé"
                                options={etablissements.map((item) => ({
                                    value: JSON.stringify(item),
                                    label: item?.nom,
                                }))}
                                value={pec?.etablissement && Object.keys(pec.etablissement || {}).length
                                    ? JSON.stringify(pec.etablissement)
                                    : undefined}
                                onChange={(value) => {
                                    if (!value) {
                                        handleChange({}, "etablissement");
                                        setEtablissementState("error");
                                        return;
                                    }
                                    handleChange(JSON.parse(value), "etablissement");
                                    setEtablissementState("success");
                                }}
                                optionFilterProp="label"
                                allowClear
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item label={L.nature} validateStatus={validateStatusOf(natureActeState)}>
                            <Input
                                id="natureActe"
                                name="natureActe"
                                value={pec?.natureActe}
                                placeholder={L.naturePh}
                                status={natureActeState === "error" ? "error" : null}
                                onChange={(event) => {
                                    handleChange(event);
                                    if (event.target.value.length > 3) {
                                        setNatureActeState("success");
                                    } else {
                                        setNatureActeState("error");
                                    }
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item label={L.codification} validateStatus={validateStatusOf(codificationState)}>
                            <Input
                                id="codification"
                                name="codification"
                                value={pec?.codification}
                                type="text"
                                placeholder={L.codificationPh}
                                status={codificationState === "error" ? "error" : null}
                                onChange={(event) => {
                                    handleChange(event);
                                    if (event.target.value.length > 3) {
                                        setCodificationState("success");
                                    } else {
                                        setCodificationState("error");
                                    }
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item
                            label="Délai de validité"
                            required
                            validateStatus={validateStatusOf(delaiValiditeState)}
                            help={delaiValiditeState === "error" ? "Délai de validité obligatoire" : undefined}
                        >
                            <Input
                                id="dureeValidite"
                                name="dureeValidite"
                                value={pec?.dureeValidite ? parseInt(pec.dureeValidite, 10) : undefined}
                                placeholder="Délai de validité"
                                type="number"
                                status={delaiValiditeState === "error" ? "error" : null}
                                addonAfter={selectAfter}
                                onChange={(event) => {
                                    handleChange(event);
                                    setDelaiValiditeState("success");
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item
                            label={`${L.cout} (calculé automatiquement)`}
                            tooltip="Somme des montants retenus des actes / travaux ci-dessous."
                        >
                            <Input
                                id="montant"
                                name="montant"
                                value={formatAmount(pec?.montant)}
                                type="text"
                                placeholder={L.cout}
                                addonAfter="FCFA"
                                readOnly
                                disabled
                                style={{ fontWeight: 600 }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>

            <Divider orientation="left" style={{ margin: "4px 0 12px" }}>
                <Text strong>{isBon ? "Travaux / pièces" : "Actes de la prise en charge"}</Text>
            </Divider>

            <Table
                size="small"
                bordered
                rowKey={(_, index) => index}
                columns={acteColumns}
                dataSource={actes}
                pagination={false}
                locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={isBon ? "Aucun travail / pièce" : "Aucun acte"} /> }}
                summary={() => {
                    const totalRetenu = (actes || []).reduce((acc, a) => acc + Number(a?.montantRetenue || 0), 0);
                    return actes && actes.length ? (
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0} colSpan={2} align="right">
                                <Text strong>Total retenu</Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1} align="right">
                                <Text strong style={{ color: "#242166" }}>{displayNumbers(totalRetenu)}</Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={2} colSpan={2} />
                        </Table.Summary.Row>
                    ) : null;
                }}
            />

            <div style={{ marginTop: 12 }}>
                <Button type="dashed" icon={<PlusOutlined />} onClick={() => addActe()}>
                    {L.addActe}
                </Button>
            </div>

            <Modal
                title={editActe
                    ? (isBon ? "Modifier le travail / la pièce" : "Modifier l'acte")
                    : L.addActe}
                centered
                open={acteModal}
                onOk={() => {
                    const targetIndex = editActe ? selectedActe : actes.length - 1;
                    if (targetIndex === undefined || targetIndex < 0) {
                        setActeModal(false);
                        setEditActe(false);
                        setSelectedActe(undefined);
                        return;
                    }
                    const newActes = [...actes];
                    const currentActe = { ...newActes[targetIndex] };
                    const montantReclame = Number(currentActe?.montantReclame || 0);
                    const montantRetenue = Number(currentActe?.montantRetenue || 0);
                    currentActe.montantReclame = montantReclame;
                    currentActe.montantRetenue = montantRetenue;
                    currentActe.montantExclu = montantReclame - montantRetenue;
                    newActes[targetIndex] = currentActe;
                    const totalRetenu = newActes.reduce(
                        (acc, item) => acc + Number(item?.montantRetenue || 0),
                        0
                    );
                    setPEC((previous) => ({ ...(previous || { ...initPEC }), montant: totalRetenu }));
                    setActes(newActes);
                    setActeModal(false);
                    setEditActe(false);
                    setSelectedActe(undefined);
                }}
                onCancel={() => {
                    if (!editActe) {
                        setActes((previous) => previous.slice(0, -1));
                    }
                    setActeModal(false);
                    setEditActe(false);
                    setSelectedActe(undefined);
                }}
                zIndex={1000}
                okText={editActe ? "Enregistrer" : "Ajouter"}
                cancelText="Annuler"
            >
                <Form layout="vertical" style={{ marginTop: 8 }}>
                    <Row gutter={16}>
                        <Col xs={24}>
                            <Form.Item label={L.acteLabel}>
                                <Select
                                    style={{ width: "100%" }}
                                    showSearch
                                    id="acte"
                                    name="acte"
                                    value={actes[editActe ? selectedActe : actes.length - 1]?.acte}
                                    placeholder={L.actePh}
                                    onChange={(value) => {
                                        const newActes = [...actes];
                                        newActes[editActe ? selectedActe : actes.length - 1].acte = value;
                                        setActes(newActes);
                                    }}
                                    options={natureActesFiltres?.map((na) => ({ label: na.libelleParametre, value: na.libelleParametre }))}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item label="Montant réclamé">
                                <AmountInputNumber
                                    id="montantReclame"
                                    name="montantReclame"
                                    value={actes[editActe ? selectedActe : actes.length - 1]?.montantReclame}
                                    placeholder="Montant réclamé"
                                    min={0}
                                    style={{ width: "100%" }}
                                    onChange={(value) => {
                                        const newActes = [...actes];
                                        newActes[editActe ? selectedActe : actes.length - 1].montantReclame = Number(value ?? 0);
                                        setActes(newActes);
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item label="Montant retenu">
                                <AmountInputNumber
                                    id="montantRetenue"
                                    name="montantRetenue"
                                    value={actes[editActe ? selectedActe : actes.length - 1]?.montantRetenue}
                                    placeholder="Montant retenu"
                                    min={0}
                                    style={{ width: "100%" }}
                                    onChange={(value) => {
                                        const newActes = [...actes];
                                        newActes[editActe ? selectedActe : actes.length - 1].montantRetenue = Number(value ?? 0);
                                        setActes(newActes);
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24}>
                            <div style={{ background: "#f6f6fb", borderRadius: 8, padding: "10px 14px", display: "flex", justifyContent: "space-between" }}>
                                <Text type="secondary">Montant exclu (réclamé − retenu)</Text>
                                <Text strong style={{ color: "#b91c1c" }}>
                                    {displayNumbers(
                                        Number(actes[editActe ? selectedActe : actes.length - 1]?.montantReclame || 0)
                                        - Number(actes[editActe ? selectedActe : actes.length - 1]?.montantRetenue || 0)
                                    )}
                                </Text>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </Modal>
    );
};

AjouterPriseEnCharge.propTypes = {
    open: PropTypes.bool,
    priseEnCharge: PropTypes.object,
    edit: PropTypes.bool,
    setOpen: PropTypes.func,
    sinistre: PropTypes.object,
    onSuccess: PropTypes.func,
    onClose: PropTypes.func,
};

export default AjouterPriseEnCharge;
